import $ from 'jquery';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import throttle from 'lodash/throttle';
import moment from 'moment';
import 'slick-carousel';
import './pikaday.jquery.js';
import select2 from 'select2';

window.jQuery = $;
imagesLoaded.makeJQueryPlugin($);
import 'magnific-popup';

select2($);

const $breakpointSM = 767;
const $breakpointMD = 992;
const $breakpointLG = 1200;

// lightbox custom closing
function lightboxClose() {
  $('.lightbox-close').on('click', (event) => {
    event.preventDefault();
  });
}

// layout Masonry after each image loads
$('.grid').imagesLoaded().progress(() => {
  const msnry = new Masonry('.grid', {
    // isFitWidth: true,
  });
  $('.grid .grid-item').addClass('grid-item--visible');

  $('.load-more').addClass('show');

  return msnry;
});

// menu
function toggleMenu(event) {
  event.preventDefault();
  $('.menu-toggle, .nav--header, .navigation--main').toggleClass('open');
  $('.header').toggleClass('menu-open');
}

function closeMenu() {
  $('.menu-toggle, .nav--header, .navigation--main').removeClass('open');
  $('.header').removeClass('menu-open');
}

$('.menu-toggle').on('click', toggleMenu);

function initLightbox() {
  // gallery lightbox
  $('.lightbox').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: {
      enabled: true,
      tCounter: '',
    },
    image: {
      markup: `<div class="mfp-figure">
                <div class="mfp-img"></div>
              </div>`,
    },
    mainClass: 'mfp-fade',
    removalDelay: 300,
    callbacks: {
      open: () => {
        $('.mfp-wrap').append('<a href="#" class="lightbox-close"></a>');
        lightboxClose();
      },
    },
  });
}
if ($('.lightbox').length)
{
  initLightbox();
}

// load more functionality
$('.load-more').on('click', function onLoadMore(e) {
  e.preventDefault();
  $(this).addClass('loading');

  const $dis = $(this);
  const $what = $dis.data('load');
  const $count = $dis.data('count');
  const $nextPage = $dis.data('next-page');
  if (!$what) return false;

  let $more = $what + $nextPage + '/';
  if($what == 'gallery') {
    $more = $what + '?pg=' + $nextPage;
  }

  const $load = $more + ' .items';

  $( '.section--' + $what + ' .load-here' ).load( $load, function afterLoad() {
    $('.section--' + $what + ' .load-here .item').parent().unwrap();
    $('.section--' + $what + ' .load-more-wrapper').before('<div class="load-here"></div>');
    $dis.removeClass('loading');
    if($what == 'gallery') {
      $('.grid-item').addClass('grid-item--visible');

      initLightbox();
    }
    // hide load more button if loaded count is same as all item count
    const $visibleBoxes = $('.section--' + $what + ' .items .item').length;
    if ($count <= $visibleBoxes) {
      $dis.hide();
    }
  });
  $dis.data('next-page', $nextPage + 1);
});

const hash = window.location.hash;
if (hash) {
  window.scrollTo(0,0);
  const $target = $(hash);
  const $goto = $target.length ? $target : $(`[name=${hash.slice(1)}]`);
  if ($goto.length) {
    $('html, body').animate({
      scrollTop: $goto.offset().top - 134,
    }, 1000);
  }
}

// handle links with ids
$('a[href*="#"]:not([href="#"])').click(function scrollToDivClick() {
  closeMenu();

  if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
    && location.hostname === this.hostname) {
    const $target = $(this.hash);
    const $goto = $target.length ? $target : $(`[name=${this.hash.slice(1)}]`);
    if ($goto.length) {
      $('html, body').animate({
        scrollTop: $goto.offset().top - 134,
      }, 1000);

      return false;
    }
  }

  return true;
});

$('.datepicker').append('<span>');
$('.datepicker').pikaday({
  format: 'DD-MM-YYYY',
});

$('.selectmenu').select2({
  minimumResultsForSearch: Infinity
});

$('.watch-video').on('click', function(event) {
  event.preventDefault();
  $('.video__frame').fadeOut();
  $('.video_iframe_wrapper').fadeIn();
  const url = $('.video_iframe_wrapper iframe').attr('src');
  $('.video_iframe_wrapper iframe').attr('src', url + '&autoplay=1');
});

$('.js-carousel').slick({
  dots: false,
  // infinite: true,
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false,
  speed: 4000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true
});

$('.gallery').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    centerPadding: 0,
    speed: 2000,
    arrows: true,
    variableWidth: false,
    centerMode: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    responsive: [
    {
      breakpoint: $breakpointSM,
      settings: {
        arrows: false,
      }
    },
  ]
});

$('.gallery-case-study').slick({
  dots: false,
  infinite: true,
  centerPadding: 0,
  speed: 1000,
  arrows: true,
  variableWidth: false,
  centerMode: true,
  slidesToScroll: 1,
  slidesToShow: 1,
});

function handleTeamMember(e) {
  // get id / key of the person
  const hash = e.currentTarget.hash.replace('#', '');

  // get the bio object based on the key
  const $bio = $(`[data-bio="${hash}"]`);

  // get article object based on the selected bio
  const $article = $(`[data-team-row="${$bio.data('bio-row')}"]`);

  // stitch it together and show it
  $article.html($bio.html()).parent().slideDown(300);
}

$('.team-member').on('click', function(e) {
  e.preventDefault();

  if ($(window).width() < $breakpointMD) {
    if ($(this).hasClass('viewing')) {
      $('.team-member').removeClass('viewing');
      $('.team-member__content').slideUp(300);
    } else {
      $('.team-member').removeClass('viewing');
      $(this).addClass('viewing');
      const $dis = $(this);
      if ($('.team-member__content').is(":visible")) {
        $('.team-member__content').slideUp(300, function() {
          setTimeout(() => {
            $dis.parent().find('.team-member__content').slideDown();
          }, 300);
        });
      } else {
        $dis.parent().find('.team-member__content').slideDown();
      }
    }
  } else {
    // if clicking the same one
    if($(this).hasClass('viewing')) {
      // just close it
      $('.team-member').removeClass('viewing');
      $('.team-row__bio').slideUp(300);
    } else {
      $('.team-member').removeClass('viewing');
      $(this).addClass('viewing');

      // otherwise check if any is visible
      if ($('.team-row__bio').is(":visible")) {
        // if yes, close it first and then handle team member
        $('.team-row__bio').slideUp(300, function() {
          setTimeout(() => {
            handleTeamMember(e);
          }, 300);
        });
      } else {
        // otherwise handle team member right away
        handleTeamMember(e);
      }
    }
  }
});